import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectsReducerCreator } from '../types';

const setProjectToEditReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string | null>) => {
    state.projectToEdit = action.payload;
  });
};

export default setProjectToEditReducer;
